import { 
    SET_SIGNALR_HUB, 
    SET_CHAT_NEW_MESSAGE_WARNING
} from './HubActionType'

export default (state, action) => {
    switch (action.type) {
        case SET_SIGNALR_HUB:
            return {
                ...state,
                hubConnection: action.payload
            }
        case SET_CHAT_NEW_MESSAGE_WARNING:
            return {
                ...state,
                // chatNewMessageWarning: [...state.chatNewMessageWarning, action.payload]
                chatNewMessageWarning: state.chatNewMessageWarning.push(action.payload)
            }
        default:
            return state
    }
}
